import apiClient from '../apiClient';
import { PUT_ACCOMMODATION_SUPPLIER_URL } from '../apiUrl';

const putAccommodationSupplierApi = (companyCode, data) => {
  return apiClient.put(PUT_ACCOMMODATION_SUPPLIER_URL(companyCode), data);
};

export default putAccommodationSupplierApi;
